import type React from 'react';
import { theme } from '@forethought-technologies/forethought-elements';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useAppSelector } from '../../hooks';
import { selectLegibleElementColor } from 'reducers/config';
import { LARGE_WIDGET_WIDTH } from 'embed/constants';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    large: true;
    lg: false;
    md: false;
    sm: false;
    standard: true;
    xl: false;
    xs: false;
  }
}

export const CustomThemeProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const legibleElementColor = useAppSelector(selectLegibleElementColor);

  const customTheme = createTheme({
    ...theme,
    breakpoints: {
      values: {
        large: LARGE_WIDGET_WIDTH,
        standard: 0,
      },
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            '::placeholder': {
              color: theme.palette.colors.grey[500],
              opacity: 1,
            },
          },
        },
      },
    },
    palette: {
      ...theme.palette,
      primary: {
        main: legibleElementColor,
      },
    },
  });

  return <ThemeProvider theme={customTheme}>{children}</ThemeProvider>;
};
